export default {
  en: {
    minute: 'minute | minutes',
    hour: 'hour | hours',
    day: 'day | days',
    week: 'week | weeks',
    month: 'month | months',
    year: 'year | years',
  },
  es: {
    minute: 'minuto | minutos',
    hour: 'hora | horas',
    day: 'día | días',
    week: 'semana | semanas',
    month: 'mes | meses',
    year: 'año | años',
  },
  fr: {
    minute: 'minute | minutes',
    hour: 'heure | heures',
    day: 'jour | jours',
    week: 'semaine | semaines',
    month: 'mois | mois',
    year: 'année | années'
}

};
